import React from 'react';
import PropTypes from 'prop-types';

import Subtitle from 'ui/text/Subtitle';
import Description from 'ui/text/Description';
import CustomChip from 'ui/CustomChip';

import formattedDate from 'utils/formattedDate';

import { Divider } from '@mui/material';

const Header = ({ event_title, title, variant_label, start_date, description, collected, collected_at }) => {

  return (
    <div className='fullwidth-card-header'>
        <Subtitle>{event_title}</Subtitle>
        {start_date && <Description>{formattedDate(start_date, 'datetime')}</Description>}
        <Description>{title}{variant_label && ` — ${variant_label}`}</Description>

        <Divider />

        <Description>{description}</Description>

        {collected &&
          <>
            <CustomChip label="collected" styleKey="active" padded />
            {collected_at && <Description secondary>{formattedDate(collected_at, 'datetime')}</Description>}
          </>}
    </div>
  );
};

Header.propTypes = {
    event_title: PropTypes.string,
    title: PropTypes.string,
  variant_label: PropTypes.string,
    start_date: PropTypes.string,
    description: PropTypes.string,
    collected: PropTypes.bool,
    collected_at: PropTypes.string,
};

export default Header;
